<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
        <ion-button
          @click="$store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"
          ></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <h1>Einstellungen</h1>

      <ion-item>
        <ion-label class="ion-text-wrap">SMS-Benachrichtigungen</ion-label>
        <ion-toggle
          @click="
            toggleUserTag('pushNotifications', 'notifications-yes', false)
          "
          v-model="pushNotifications"
        >
        </ion-toggle>
      </ion-item>

      <ion-list class="ion-padding-start ion-margin-top">
        <b>Wählen Sie Ihre Wunschthemen aus:</b>
        <!-- <ion-item>
          <ion-label class="ion-text-wrap">Arzttermine</ion-label>
          <ion-toggle
            :disabled="!pushNotifications"
            @click="
              toggleUserTag(
                'pushDoctorAppointments',
                'sms-doctor-appointments-no'
              )
            "
            v-model="pushDoctorAppointments"
          >
          </ion-toggle>
        </ion-item> -->
        <ion-item>
          <ion-label class="ion-text-wrap"
            >Informatives zu meiner Krankheit</ion-label
          >
          <ion-toggle
            :disabled="!pushNotifications"
            @click="toggleUserTag('pushInfos', 'sms-infos-no')"
            v-model="pushInfos"
          >
          </ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap">Vorsorgetermine</ion-label>
          <ion-toggle
            :disabled="!pushNotifications"
            @click="
              toggleUserTag(
                'pushPreventionAppointments',
                'sms-prevention-appointments-no'
              )
            "
            v-model="pushPreventionAppointments"
          >
          </ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap">Tabletteneinnahme</ion-label>
          <ion-toggle
            :disabled="!pushNotifications"
            @click="toggleUserTag('pushPills', 'sms-pills-no')"
            v-model="pushPills"
          >
          </ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap">Physiotherapie</ion-label>
          <ion-toggle
            :disabled="!pushNotifications"
            @click="
              toggleUserTag('smsPhysiotherapy', 'sms-physiotherapy-yes', false)
            "
            v-model="smsPhysiotherapy"
          >
          </ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap">Mentale Gesundheit</ion-label>
          <ion-toggle
            :disabled="!pushNotifications"
            @click="
              toggleUserTag('smsMentalhealth', 'sms-mentalhealth-yes', false)
            "
            v-model="smsMentalhealth"
          >
          </ion-toggle>
        </ion-item>
        <ion-item>
          <ion-label class="ion-text-wrap"
            >Schwangerschaft/Kinderwunsch</ion-label
          >
          <ion-toggle
            :disabled="!pushNotifications"
            @click="toggleUserTag('smsPregnancy', 'sms-pregnancy-yes', false)"
            v-model="smsPregnancy"
          >
          </ion-toggle>
        </ion-item>
      </ion-list>

      <ion-item class="ion-margin-top" v-if="isNativeBiometricAvailable">
        <ion-label class="ion-text-wrap"
          >{{ isNativeBiometricFaceId ? "Face ID" : "Touch ID" }} statt Passwort
          verwenden</ion-label
        >
        <ion-toggle v-model="useBiometric" @click="toggleUseBiometric()">
        </ion-toggle>
      </ion-item>

      <ion-item @click="showDeleteAccount = true" button>
        <ion-label color="danger">Benutzerkonto löschen</ion-label>
        <ion-icon :icon="trash" slot="end" color="danger"></ion-icon>
      </ion-item>
    </ion-content>

    <ion-modal
      :is-open="showDeleteAccount"
      :css-class="['c-autoheight-modal']"
      @didDismiss="showDeleteAccount = false"
    >
      <ion-page>
        <div class="ion-padding modal-content">
          <modal-close />
          <h1>Benutzerkonto löschen</h1>
          <p>
            Möchten Sie Ihr Benutzerkonto und alle zugehörigen Daten wirklich
            löschen? Bestätigen Sie bitte mit Ihrem Passwort.
          </p>
          <ion-item lines="none">
            <ion-label position="stacked">Passwort</ion-label>
            <ion-input
              :type="passwordType"
              v-model="deleteAccountPassword"
              class="u-pointer-auto"
              tabindex="1"
            >
              <ion-button
                fill="clear"
                slot="end"
                @click="togglePasswordType()"
                style="order: 1"
                tabindex="2"
              >
                <ion-icon :icon="passwordIcon" slot="icon-only"></ion-icon
              ></ion-button>
            </ion-input>
          </ion-item>
          <div class="ion-text-center ion-margin-top">
            <ion-button
              :disabled="deleteAccountPassword === ''"
              @click="deleteAccount()"
              >Bestätigen</ion-button
            >
          </div>
        </div>
      </ion-page>
    </ion-modal>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
  IonButton,
  IonToggle,
  IonBackButton,
  modalController,
  IonInput,
  IonModal,
  alertController,
} from "@ionic/vue";
import { NativeBiometric, BiometryType } from "capacitor-native-biometric";
import { Capacitor } from "@capacitor/core";
import { Preferences as Storage } from "@capacitor/preferences";
import AlertModal from "@/components/AlertModal";
import { apiAddUserTag, apiGetUser, apiRemoveUserTag } from "@/api/user";
import { trash, eye, eyeOff } from "ionicons/icons";
import { ref } from "vue";
import axios from "@/plugins/axios";
import { apiLogout } from "@/api/auth";
import ModalClose from "@lib/components/ModalClose";
import { useStore } from "vuex";

export default {
  setup() {
    const showDeleteAccount = ref(false);
    const deleteAccountPassword = ref("");
    const passwordType = ref("password");
    const passwordIcon = ref(eye);
    const togglePasswordType = () => {
      if (passwordType.value === "password") {
        passwordType.value = "text";
        passwordIcon.value = eyeOff;
      } else {
        passwordType.value = "password";
        passwordIcon.value = eye;
      }
    };
    const store = useStore();
    const deleteAccount = async () => {
      store.commit("setShowLoading", true);
      const response = await axios.post(
        "?Mode=General&Function=DeleteAccount",
        "Password=" + deleteAccountPassword.value
      );
      if (response.data.Status === "Success" && response.data.Result) {
        showDeleteAccount.value = false;
        apiLogout();
        const alert = await alertController.create({
          header: "Benutzerkonto gelöscht",
          message: "Ihr Benutzerkonto wurde erfolgreich gelöscht.",
          buttons: ["OK"],
        });
        alert.present();
      }
    };
    return {
      trash,
      showDeleteAccount,
      deleteAccount,
      deleteAccountPassword,
      togglePasswordType,
      passwordType,
      passwordIcon,
    };
  },
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonContent,
    IonList,
    IonItem,
    IonLabel,
    IonIcon,
    IonButton,
    IonToggle,
    IonBackButton,
    IonInput,
    IonModal,
    ModalClose,
  },
  data() {
    return {
      pushNotifications: false,
      pushDoctorAppointments: true,
      pushInfos: true,
      pushPreventionAppointments: true,
      pushPills: true,
      smsPhysiotherapy: false,
      smsMentalhealth: false,
      smsPregnancy: false,
      useBiometric: false,
      isNativeBiometricAvailable: false,
      isNativeBiometricFaceId: false,
    };
  },
  ionViewWillEnter() {
    apiGetUser().then(() => {
      if (this.$store.state.user.Tags.includes("notifications-yes")) {
        this.pushNotifications = true;
      }
      if (this.$store.state.user.Tags.includes("sms-doctor-appointments-no")) {
        this.pushDoctorAppointments = false;
      }
      if (this.$store.state.user.Tags.includes("sms-infos-no")) {
        this.pushInfos = false;
      }
      if (
        this.$store.state.user.Tags.includes("sms-prevention-appointments-no")
      ) {
        this.pushPreventionAppointments = false;
      }
      if (this.$store.state.user.Tags.includes("sms-pills-no")) {
        this.pushPills = false;
      }
      if (this.$store.state.user.Tags.includes("sms-physiotherapy-yes")) {
        this.smsPhysiotherapy = true;
      }
      if (this.$store.state.user.Tags.includes("sms-mentalhealth-yes")) {
        this.smsMentalhealth = true;
      }
      if (this.$store.state.user.Tags.includes("sms-pregnancy-yes")) {
        this.smsPregnancy = true;
      }
    });

    // Check if biometrics are available and which type is supported
    if (Capacitor.isNativePlatform()) {
      NativeBiometric.isAvailable().then((result) => {
        this.isNativeBiometricAvailable = result.isAvailable;
        this.isNativeBiometricFaceId =
          result.biometryType == BiometryType.FACE_ID;
        if (this.isNativeBiometricAvailable) {
          Storage.get({ key: "useBiometric" }).then(({ value }) => {
            if (value === "true") {
              this.useBiometric = true;
            }
          });
        }
      });
    }
  },
  methods: {
    async toggleUserTag(dataName, tag, isNegation = true) {
      this.$store.commit("setShowLoading", true);
      let response = null;
      if (isNegation) {
        if (this[dataName]) {
          response = await apiAddUserTag(tag);
        } else {
          response = await apiRemoveUserTag(tag);
        }
      } else {
        if (!this[dataName]) {
          response = await apiAddUserTag(tag);
        } else {
          response = await apiRemoveUserTag(tag);
        }
      }
      if (response?.data?.Status !== "Success") {
        this[dataName] = !this[dataName];
      }
    },
    toggleUseBiometric(event) {
      if (!this.useBiometric) {
        Storage.get({ key: "useBiometric" }).then(({ value }) => {
          if (!value) {
            modalController
              .create({
                component: AlertModal,
                cssClass: "c-autoheight-modal",
                componentProps: {
                  message:
                    "Sie können " +
                    (this.isNativeBiometricFaceId ? "Face ID" : "Touch ID") +
                    " nach dem nächsten Login vollständig aktivieren.",
                  buttons: ["Ok"],
                },
              })
              .then((modal) => {
                Storage.set({
                  key: "useBiometric",
                  value: "true",
                });
                modal.present();
              });
          } else {
            NativeBiometric.verifyIdentity({
              reason: "Für einfachen Login",
              title:
                (this.isNativeBiometricFaceId.value ? "Face ID" : "Touch ID") +
                " aktivieren",
              subtitle: "Bitte verifizieren Sie Ihre Identität",
              description: "",
              negativeButtonText: "Abbrechen",
            })
              .then(() => {
                Storage.set({
                  key: "useBiometric",
                  value: "true",
                });
              })
              .catch((error) => {
                console.log(error);
                this.useBiometric = false;
              });
          }
        });
      } else {
        Storage.set({
          key: "useBiometric",
          value: "false",
        });
      }
    },
  },
};
</script>

<style></style>
